module.exports = __webpack_public_path__ + "media/images/howitworks3-820c8308a056a15c5bb887a05c0fdc05.png";